import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedCheckProps {
  size?: number;
  className?: string;
  delay?: number;
}
export function AnimatedCheck({
  size = 72,
  className = '',
  delay = 0
}: AnimatedCheckProps) {
  return <motion.div initial={{
    scale: 0.9,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    duration: 0.28,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} className={`relative grid place-items-center rounded-full bg-positive-500 text-white ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-664" data-mp="2iel2wvvg5xwf">
      <motion.span className="absolute inset-0 rounded-full bg-positive-500" initial={{
      scale: 1,
      opacity: 0.35
    }} animate={{
      scale: 1.6,
      opacity: 0
    }} transition={{
      duration: 0.9,
      ease: 'easeOut',
      delay: delay + 0.15
    }} aria-hidden data-id="element-665" data-mp="2naa6daal7yy0" />
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} fill="none" aria-hidden className="relative" data-id="element-666" data-mp="3b1xkermr3fiv">
        <motion.path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" strokeWidth={2.6} strokeLinecap="round" strokeLinejoin="round" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1],
        delay: delay + 0.18
      }} data-id="element-667" data-mp="360rn0gi5b430" />
      </svg>
    </motion.div>;
}